var _path, _path2, _path3, _path4, _path5, _circle, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIntroTapCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.278 18.5765L13.4997 2.81957L1.4994 5.00059L4.46035 20.6603L16.278 18.5765Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80469 16.6953L12.7135 15.6534",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28516 13.7344L12.194 12.6925",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 10.7812L11.6745 9.73936",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 7.82812L8.19661 7.30718",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1506,
    cy: 6.78772,
    r: 1,
    transform: "rotate(-10 11.1506 6.78772)",
    fill: "#20242E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8691 2.97103C16.8128 2.64729 16.8873 2.31443 17.0764 2.04568C17.17 1.91261 17.289 1.79929 17.4264 1.71217C17.5638 1.62506 17.717 1.56587 17.8773 1.53797C18.0376 1.51008 18.2019 1.51404 18.3606 1.54961C18.5194 1.58518 18.6696 1.65168 18.8027 1.74531C18.9358 1.83893 19.0491 1.95785 19.1362 2.09527C19.2233 2.2327 19.2825 2.38593 19.3104 2.54623L21.0804 12.7183L20.2137 14.9651L18.6391 13.1431L16.8691 2.97103Z",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIntroTapCreate);
export default __webpack_public_path__ + "static/media/invoice-intro-tap-create.88429fb7ee6d6acf3cde1f5e46b9994d.svg";
export { ForwardRef as ReactComponent };